import { message } from 'antd';

import { call, put, takeEvery, all, fork, takeLatest } from 'redux-saga/effects'
import {
    FETCH_USERS, FETCH_USERS_START, FETCH_USERS_SUCCESS, FETCH_USERS_ERROR, ADD_USER, ADD_USER_SUCCESS, ADD_USER_ERROR,
    UPDATE_USER_SITES, UPDATE_USER_SITES_SUCCESS, UPDATE_USER_SITES_ERROR, FETCH_ALL_TECHNICIANS, FETCH_ALL_TECHNICIANS_START, FETCH_ALL_TECHNICIANS_SUCCESS, FETCH_ALL_DOCTORS, FETCH_ALL_DOCTORS_SUCCESS, FETCH_ALL_DOCTORS_ERROR, FETCH_ALL_TECHNICIANS_ERROR, UPDATE_USER_ACCOUNT, UPDATE_USER_ACCOUNT_START, UPDATE_USER_ACCOUNT_SUCCESS, UPDATE_USER_ACCOUNT_ERROR, RESET_USER_PASSWORD, RESET_USER_PASSWORD_START, RESET_USER_PASSWORD_SUCCESS, RESET_USER_PASSWORD_ERROR, FETCH_RIS_USERS_WITH_MIPS, FETCH_RIS_USERS_WITH_MIPS_SUCCESS, FETCH_RIS_USERS_WITH_MIPS_ERROR, FETCH_RIS_USERS_WITH_MIPS_START, CREATE_RIS_USER_START, CREATE_RIS_USER_SUCCESS, CREATE_RIS_USER_ERROR, CREATE_RIS_USER, ADD_UPDATE_RIS_USER_MIPS, ADD_UPDATE_RIS_USER_MIPS_START, ADD_UPDATE_RIS_USER_MIPS_SUCCESS, ADD_UPDATE_RIS_USER_MIPS_ERROR, SET_USERS_PAGINATION, UNASSIGN_USER_MIP, UNASSIGN_USER_MIP_SUCCESS, UNASSIGN_USER_MIP_ERROR,
    UPDATE_RIS_USER, UPDATE_RIS_USER_START, UPDATE_RIS_USER_SUCCESS, UPDATE_RIS_USER_ERROR, DELETE_RIS_USER, DELETE_RIS_USER_SUCCESS, DELETE_RIS_USER_ERROR
} from "../../actions/admin/usersActions";
import { HIDE_MODAL, SUBMIT_START, SUBMIT_ERROR, UPDATE_MODAL_DATA } from "../../actions/admin/modalActions"
import { getAllUsers, registerUser, updateUserSitesAPI, getAllTechniciansAPI, getAllDoctorsAPI, updateUserAccountAPI, resetUserPasswordAPI, getRisUsersWithMipsAPI, addUpdateRisUserMipsAPI, createRisUserAPI, unAssignUserMipAPI, updateRisUserAPI, deleteRisUserAPI } from "../../../services/users-service";
import { history } from '../../store';

function* fetchUsers({ payload }) {
    try {
        yield put({ type: FETCH_USERS_START })
        const response = yield call(getAllUsers, payload);
        if (response.success) {

            const pagination = {
                currentPage: payload.page,
                pageSize: payload.size,
                totalPages: response.data.totalPages,
                totalItems: response.data.totalItems,
            }
            yield put({ type: SET_USERS_PAGINATION, pagination });
            yield put({ type: FETCH_USERS_SUCCESS, users: response.data.users })
        } else {
            yield put({ type: FETCH_USERS_ERROR, error: response.error })
            message.error('Failed to fetch users!');
        }
    } catch (error) {
        yield put({ type: FETCH_USERS_ERROR, error })
        message.error('Failed to fetch users!');
    }
}

function* addUser({ user }) {
    try {
        yield put({ type: SUBMIT_START })
        const response = yield call(registerUser, user);
        if (response.success) {
            yield put({ type: ADD_USER_SUCCESS, user: response.user })
            message.success('User created successfully.');
            history.replace({
                pathname: '/admin/master/edit-user',
                state: {
                    formType: "Edit",
                    userId: response.user.userId
                }
            });
        } else {
            yield put({ type: ADD_USER_ERROR, error: response.error })
            yield put({ type: SUBMIT_ERROR })
            message.error(response.error);
        }
    } catch (error) {
        yield put({ type: ADD_USER_ERROR, error })
        yield put({ type: SUBMIT_ERROR })
        message.error('Failed to create user!');
    }
}

function* updateUserAccount({ userAccount }) {
    try {
        yield put({ type: UPDATE_USER_ACCOUNT_START })
        const response = yield call(updateUserAccountAPI, userAccount);
        if (response.success) {
            yield put({ type: UPDATE_USER_ACCOUNT_SUCCESS, userAccount: response.userAccount })
            yield put({ type: HIDE_MODAL })
            message.success('User account updated successfully.');
        } else {
            yield put({ type: UPDATE_USER_ACCOUNT_ERROR, error: response.error })
            message.error('Failed to update user account!');
        }
    } catch (error) {
        yield put({ type: UPDATE_USER_ACCOUNT_ERROR, error })
        message.error('Failed to update user account!');
    }
}

// function* updateUserSites({ user }) {
//     try {
//         yield put({ type: SUBMIT_START })
//         let userSites = [];
//         user.site.forEach(site => {
//             userSites.push({
//                 id: 0,
//                 mipId: site.mipId,
//                 userId: user.userId
//             });
//         });
//         const response = yield call(updateUserSitesAPI, userSites);
//         if (response.success) {
//             yield put({ type: UPDATE_USER_SITES_SUCCESS, user })
//             yield put({ type: HIDE_MODAL })
//             message.success('User site info updated successfully.');
//         } else {
//             yield put({ type: UPDATE_USER_SITES_ERROR, error: response.error })
//             yield put({ type: SUBMIT_ERROR })
//             message.error('Failed to update user site info!');
//         }
//     } catch (error) {
//         yield put({ type: UPDATE_USER_SITES_ERROR, error })
//         yield put({ type: SUBMIT_ERROR })
//         message.error('Failed to update user site info!');
//     }
// }

function* resetUserPassword({ user }) {
    try {

        yield put({ type: RESET_USER_PASSWORD_START })
        const response = yield call(resetUserPasswordAPI, user.email);
        if (response.success) {
            yield put({ type: RESET_USER_PASSWORD_SUCCESS, accountInfo: response.accountInfo });
            yield put({ type: UPDATE_MODAL_DATA, data: { ...user, ...response.accountInfo } });
            message.success('Password reset successfully.');
        } else {
            yield put({ type: RESET_USER_PASSWORD_ERROR, error: response.error })
            message.error('Failed to reset password!');
        }
    } catch (error) {
        yield put({ type: RESET_USER_PASSWORD_ERROR, error })
        message.error('Failed to reset password!');
    }
}

function* fetchTechnicians({ payload }) {
    try {
        // yield put({ type: FETCH_ALL_TECHNICIANS_START })
        const response = yield call(getAllTechniciansAPI, payload.siteId);
        if (response.success) {
            yield put({ type: FETCH_ALL_TECHNICIANS_SUCCESS, technicians: response.technicians })
        } else {
            yield put({ type: FETCH_ALL_TECHNICIANS_ERROR, error: response.error })
            message.error('Failed to fetch technicians!');
        }
    } catch (error) {
        yield put({ type: FETCH_ALL_TECHNICIANS_ERROR, error })
        message.error('Failed to fetch technicians!');
    }
}

function* fetchDoctors() {
    try {
        // yield put({ type: FETCH_ALL_TECHNICIANS_START })
        const response = yield call(getAllDoctorsAPI);
        if (response.success) {
            yield put({ type: FETCH_ALL_DOCTORS_SUCCESS, doctors: response.doctors })
        } else {
            yield put({ type: FETCH_ALL_DOCTORS_ERROR, error: response.error })
            message.error('Failed to fetch doctors!');
        }
    } catch (error) {
        yield put({ type: FETCH_ALL_DOCTORS_ERROR, error })
        message.error('Failed to fetch doctors!');
    }
}

function* getRisUsersWithMips({ userId }) {
    try {
        yield put({ type: FETCH_RIS_USERS_WITH_MIPS_START })
        const response = yield call(getRisUsersWithMipsAPI, userId);
        if (response.success) {
            yield put({
                type: FETCH_RIS_USERS_WITH_MIPS_SUCCESS,
                payload: {
                    userId,
                    risUsers: response.data.length > 0 ? [...response.data] : []
                }
            })
        } else {
            yield put({ type: FETCH_RIS_USERS_WITH_MIPS_ERROR, error: response.error })
            message.error('Failed to fetch RIS users!');
        }
    } catch (error) {
        yield put({ type: FETCH_RIS_USERS_WITH_MIPS_ERROR, error })
        message.error('Failed to fetch RIS users!');
    }
}

function* createRisUser({ risUser }) {
    try {
        yield put({ type: CREATE_RIS_USER_START })
        const response = yield call(createRisUserAPI, risUser);
        if (response.success) {
            yield put({
                type: CREATE_RIS_USER_SUCCESS,
                risUserMips: response.risUserMips
            })
            message.success('Ris user created successfully.');
        } else {
            if (response.error) {
                yield put({ type: CREATE_RIS_USER_ERROR, error: response.error })
                message.error(response.error);
            } else {
                yield put({ type: CREATE_RIS_USER_ERROR, error: response.error })
                message.error('Failed to create ris user!');
            }
        }
    } catch (error) {
        yield put({ type: CREATE_RIS_USER_ERROR, error })
        message.error('Failed to create ris user!');
    }
}

function* addUpdateRisUserMips({ risUser }) {
    try {
        yield put({ type: ADD_UPDATE_RIS_USER_MIPS_START })
        const response = yield call(addUpdateRisUserMipsAPI, risUser);
        if (response.success) {
            yield put({
                type: ADD_UPDATE_RIS_USER_MIPS_SUCCESS,
                risUserMips: response.risUserMips
            })
            message.success('Ris user mips saved successfully.');
        } else {
            if (response.error) {
                yield put({ type: ADD_UPDATE_RIS_USER_MIPS_ERROR, error: response.error })
                message.error(response.error);
            } else {
                yield put({ type: ADD_UPDATE_RIS_USER_MIPS_ERROR, error: response.error })
                message.error('Failed to save ris user mips!');
            }
        }
    } catch (error) {
        yield put({ type: ADD_UPDATE_RIS_USER_MIPS_ERROR, error })
        message.error('Failed to save ris user mips!');
    }
}

function* updateRisUser({ risUser, callback }) {
    try {
        yield put({ type: UPDATE_RIS_USER_START })
        const response = yield call(updateRisUserAPI, risUser);
        if (response.success) {
            yield put({
                type: UPDATE_RIS_USER_SUCCESS,
                risUser: { ...risUser, ...response.risUser }
            })
            message.success('Ris user updated successfully.');
            if (callback) {
                callback();
            }
        } else {
            if (response.error) {
                yield put({ type: UPDATE_RIS_USER_ERROR, error: response.error })
                message.error(response.error);
            } else {
                yield put({ type: UPDATE_RIS_USER_ERROR, error: response.error })
                message.error('Failed to update ris user!');
            }
        }
    } catch (error) {
        yield put({ type: UPDATE_RIS_USER_ERROR, error })
        message.error('Failed to update ris user!');
    }
}

function* deleteRisUser({ payload }) {
    try {
        const response = yield call(deleteRisUserAPI, payload.userId, payload.risId);
        if (response.success) {
            yield put({
                type: DELETE_RIS_USER_SUCCESS,
                payload: payload
            })
            message.success('Ris user deleted successfully.');
        } else {
            if (response.error) {
                yield put({ type: DELETE_RIS_USER_ERROR, error: response.error })
                message.error(response.error);
            } else {
                yield put({ type: DELETE_RIS_USER_ERROR, error: response.error })
                message.error('Failed to delete ris user!');
            }
        }
    } catch (error) {
        yield put({ type: DELETE_RIS_USER_ERROR, error })
        message.error('Failed to delete ris user!');
    }
}

function* unAssignUserMip({ payload }) {
    try {
        const response = yield call(unAssignUserMipAPI, payload.userMipId);
        if (response.success) {
            yield put({
                type: UNASSIGN_USER_MIP_SUCCESS,
                user: payload
            })
            message.success('Unassigned user mip successfully');
        } else {
            if (response.error) {
                yield put({ type: UNASSIGN_USER_MIP_ERROR, error: response.error })
                message.error(response.error);
            } else {
                yield put({ type: UNASSIGN_USER_MIP_ERROR, error: response.error })
                message.error('Failed to unassign user mip!');
            }
        }
    } catch (error) {
        yield put({ type: UNASSIGN_USER_MIP_ERROR, error })
        message.error('Failed to unassign user mip!');
    }
}

function* usersWatcher() {
    yield takeEvery(FETCH_USERS, fetchUsers)
    yield takeEvery(ADD_USER, addUser)
    yield takeLatest(UPDATE_USER_ACCOUNT, updateUserAccount)
    // yield takeLatest(UPDATE_USER_SITES, updateUserSites)
    yield takeLatest(RESET_USER_PASSWORD, resetUserPassword)
    yield takeLatest(FETCH_RIS_USERS_WITH_MIPS, getRisUsersWithMips)
    yield takeLatest(CREATE_RIS_USER, createRisUser)
    yield takeLatest(ADD_UPDATE_RIS_USER_MIPS, addUpdateRisUserMips)
    yield takeLatest(UPDATE_RIS_USER, updateRisUser)
    yield takeLatest(DELETE_RIS_USER, deleteRisUser)
    yield takeLatest(UNASSIGN_USER_MIP, unAssignUserMip)
}

function* techniciansWatcher() {
    yield takeEvery(FETCH_ALL_TECHNICIANS, fetchTechnicians)
}

function* doctorsWatcher() {
    yield takeEvery(FETCH_ALL_DOCTORS, fetchDoctors)
}

export default function* rootSaga() {
    yield all([
        usersWatcher(),
        techniciansWatcher(),
        doctorsWatcher()
    ]);
}